import React from "react";
import AddProduct from "../../components/product/AddProduct";
import Navbar from "../../components/navbar/Navbar";
import { useLocation } from "react-router-dom";

const AddProductPage = () => {
  const { state } = useLocation();
  return (
    <>
      <section className="bajaj_main_block">
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-12 p-0">
              {state?.id ? (
                <Navbar content="EDIT PRODUCT" />
              ) : (
                <Navbar content="ADD PRODUCT" />
              )}
            </div>
          </div>
          <div className="row">
            <div className="col-lg-12 p-0">
              <AddProduct />
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default AddProductPage;
